import React from "react";
import { Avatar } from "@mantine/core";
import { IconUser } from "@tabler/icons-react";
import StaffAvatar from "../common/StaffAvatar/StaffAvatar";
import type { Conversation } from "../../types/messaging";
import { splitName } from "./chatHelpers";

interface ConversationAvatarProps {
  conversation: Conversation;
  size?: number;
}

/**
 * A linked conversation shows the client's initials (brand-teal StaffAvatar);
 * an unlinked, phone-only conversation shows a neutral person icon — matching
 * the mockup's linked/unlinked treatment.
 */
export const ConversationAvatar: React.FC<ConversationAvatarProps> = ({
  conversation,
  size = 44,
}) => {
  const name = conversation.client?.name;
  if (name) {
    const { firstName, lastName } = splitName(name);
    return (
      <StaffAvatar firstName={firstName} lastName={lastName} size={size} />
    );
  }
  return (
    <Avatar size={size} radius="xl" color="gray">
      <IconUser size={Math.round(size * 0.5)} stroke={1.5} />
    </Avatar>
  );
};

export default ConversationAvatar;
